module.exports = __webpack_public_path__ + "loading-bad.70f45239ed50414a7de5918d41687c86.hashedasset.png";